import { Navigate, Outlet } from "react-router-dom";

import { navigationV2 } from "@src/shared/navigation/v2";

import { SettingsLayoutV2 } from "../../../ui/layout/v2";

export function SettingsLayoutV2Route() {
  return (
    <SettingsLayoutV2>
      <Outlet />
    </SettingsLayoutV2>
  );
}

export function SettingsIndexV2Route() {
  return <Navigate replace to={navigationV2.settingsAccount()} />;
}
